import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import OverflowingText from '../foundations/OverflowingText';
import css from './AutoCompleteSingleValue.css';
import CopyToClipboardButton from './CopyToClipboardButton';

const AutoCompleteSingleValue = ({
    className = '',
    selectProps = {},
    data = {},
    isDisabled = false,
    cx = () => {},
    getStyles = () => {},
    ...props
}) => {
    const { isCopiable, getOptionLabel } = selectProps;

    return (
        <div
            style={getStyles('singleValue', props)}
            className={cx({ 'single-value': true, 'single-value--is-disabled': isDisabled }, css.singleValue)}
        >
            <div className={css.value}>
                {data.icon && <div className={classNames(css.icon, { [css.disabled]: isDisabled })}>{data.icon}</div>}
                <OverflowingText>{getOptionLabel(data)}</OverflowingText>
            </div>
            {isCopiable && !isDisabled && <CopyToClipboardButton textToCopy={getOptionLabel(data)} />}
        </div>
    );
};

AutoCompleteSingleValue.propTypes = {
    className: PropTypes.string,
    selectProps: PropTypes.objectOf(PropTypes.any),
    data: PropTypes.objectOf(PropTypes.any),
    isDisabled: PropTypes.bool,
    cx: PropTypes.func,
    getStyles: PropTypes.func,
};

export default AutoCompleteSingleValue;
